// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import React, { ComponentPropsWithRef, useEffect, useState } from 'react';
import Lottie from 'react-lottie';
import styled from 'styled-components';
import firework from '../../../assets/animations/firework.json';

const S = {
  AnimationContainer: styled.div`
    pointer-events: none;
  `,
  LottieContainer: styled.div`
    position: absolute;
    transform: translateX(-50%);
  `
}

const defaultOption = {
  loop: true,
  autoplay: false,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice'
  }
}

interface CongratulationAnimationProps extends ComponentPropsWithRef<'div'> {
  duration?: number;
  onEnd?: () => void;
}

const CongratulationAnimation = (props: CongratulationAnimationProps): JSX.Element => {
  const { duration = 5500, onEnd, ...otherProps } = props;

  useEffect(() => {
    if (onEnd) {
      const timeout = setTimeout(onEnd, duration);

      return () => {
        clearTimeout(timeout);
      }
    }
  }, [duration, onEnd]);

  const [animationOption1] = useState({
    ...defaultOption,
    animationData: firework,
  })
  const [animationOption2] = useState({
    ...defaultOption,
    animationData: firework,
  })
  const [animationOption3] = useState({
    ...defaultOption,
    animationData: firework,
  })
  const [animationOption4] = useState({
    ...defaultOption,
    animationData: firework,
  })
  const [animationOption5] = useState({
    ...defaultOption,
    animationData: firework,
  })

  const [fireworkPause1, setFireworkPause1] = useState(true);
  const [fireworkPause2, setFireworkPause2] = useState(true);
  const [fireworkPause3, setFireworkPause3] = useState(true);
  const [fireworkPause4, setFireworkPause4] = useState(true);
  const [fireworkPause5, setFireworkPause5] = useState(true);

  useEffect(() => {
    const firework1 = setTimeout(() => {
      setFireworkPause1(false);
    }, 300)

    const firework2 = setTimeout(() => {
      setFireworkPause2(false);
    }, 1000)

    const firework3 = setTimeout(() => {
      setFireworkPause3(false);
    }, 1800);

    const firework4 = setTimeout(() => {
      setFireworkPause4(false);
    }, 2700);

    const firework5 = setTimeout(() => {
      setFireworkPause5(false);
    }, 3400);

    return () => {
      clearTimeout(firework1)
      clearTimeout(firework2)
      clearTimeout(firework3)
      clearTimeout(firework4)
      clearTimeout(firework5)
    }
  }, []);

  return (
    <S.AnimationContainer {...otherProps}>
      {/* 216px, 1147px */}
      <S.LottieContainer style={{ left: 'calc(216px - 216px)', top: 'calc(1147px - 1147px)' }}>
        <Lottie options={animationOption1}
          height={57}
          width={57}
          isPaused={fireworkPause1}
        />
      </S.LottieContainer>
      {/* 407px, 1082px */}
      <S.LottieContainer style={{ left: 'calc(407px - 216px)', top: 'calc(1082px - 1147px)' }}>
        <Lottie options={animationOption2}
          height={77}
          width={77}
          isPaused={fireworkPause2}
        />
      </S.LottieContainer>
      {/* 289px, 1121px */}
      <S.LottieContainer style={{ left: 'calc(289px - 216px)', top: 'calc(1121px - 1147px)' }}>
        <Lottie options={animationOption3}
          height={67}
          width={67}
          isPaused={fireworkPause3}
        />
      </S.LottieContainer>
      {/* 407px, 1168px */}
      <S.LottieContainer style={{ left: 'calc(407px - 216px)', top: 'calc(1168px - 1147px)' }}>
        <Lottie options={animationOption4}
          height={62}
          width={62}
          isPaused={fireworkPause4}
        />
      </S.LottieContainer>
      {/* 251px, 1099px */}
      <S.LottieContainer style={{ left: 'calc(251px - 216px)', top: 'calc(1099px - 1147px)' }}>
        <Lottie options={animationOption5}
          height={77}
          width={77}
          isPaused={fireworkPause5}
        />
      </S.LottieContainer>
    </S.AnimationContainer>
  )
}

export { CongratulationAnimation as default };
